"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatFidmanSyncDate = formatFidmanSyncDate;
exports.describeFidmanUserSync = describeFidmanUserSync;
exports.FidmanUserSyncBadge = FidmanUserSyncBadge;
exports.FidmanUserSyncLine = FidmanUserSyncLine;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const TEXT_CLASS_BY_VARIANT = {
    success: "text-success",
    secondary: "text-muted",
    danger: "text-danger",
    warning: "text-warning-emphasis",
    light: "text-muted",
};
function formatFidmanSyncDate(iso) {
    if (!iso)
        return "data nieznana";
    const date = new Date(iso);
    if (Number.isNaN(date.getTime()))
        return "data nieznana";
    return date.toLocaleString("pl-PL", { dateStyle: "short", timeStyle: "short" });
}
function describeByStatus(sync, when, disabling) {
    const what = disabling ? "wyłączenie" : null;
    switch (sync.status) {
        case "SENT":
            return {
                variant: "success",
                text: "light",
                label: disabling ? "FIDman: wyłączono" : "FIDman: wysłano",
                title: disabling
                    ? `Wyłączenie konta dotarło do FIDmana ${when}.`
                    : `Konto w FIDmanie założone albo zaktualizowane ${when}.`,
            };
        case "PENDING":
            return {
                variant: "secondary",
                text: "light",
                label: what ? `FIDman: ${what} oczekuje` : "FIDman: oczekuje",
                title: `W kolejce od ${when}; serwer ponawia wysyłkę co minutę.`,
            };
        case "FAILED":
            return {
                variant: "danger",
                text: "light",
                label: what ? `FIDman: błąd ${what === "wyłączenie" ? "wyłączenia" : what}` : "FIDman: błąd",
                title: `${sync.lastError ?? "Błąd wysyłki"} (próba ${sync.attempts}, ${when}). Po 10 nieudanych próbach serwer przestaje ponawiać.`,
            };
        case "SKIPPED":
        default:
            return {
                variant: "warning",
                text: "dark",
                label: what ? `FIDman: ${what} pominięte` : "FIDman: pominięto",
                title: `${sync.skipReasonLabel ?? sync.skipReason ?? "FIDman pominął tę wysyłkę"} (${when}).`,
            };
    }
}
/** Czysta reguła: co pokazać dla flagi i ostatniej wysyłki. `null` = nic. */
function describeFidmanUserSync(enabled, sync) {
    if (!sync) {
        if (!enabled)
            return null;
        return {
            variant: "light",
            text: "dark",
            label: "FIDman: nie wysłano",
            title: "Flaga jest włączona, ale w kolejce nie ma żadnej wysyłki - konto w FIDmanie nie powstało tą drogą.",
        };
    }
    const when = formatFidmanSyncDate(sync.updatedAt);
    const disabling = sync.requestedEnabled === false;
    if (!enabled) {
        if (disabling && sync.status === "SENT")
            return null;
        if (!disabling)
            return {
                variant: "warning",
                text: "dark",
                label: "FIDman: wyłączenie nie wysłane",
                title: `Ostatnia wysyłka (${when}) włączała konto, a wyłączenia nie wysłano - konto w FIDmanie trzeba wyłączyć ręcznie.`,
            };
        return describeByStatus(sync, when, true);
    }
    return describeByStatus(sync, when, disabling);
}
function FidmanUserSyncBadge({ enabled, sync, className, }) {
    const view = describeFidmanUserSync(enabled, sync ?? null);
    if (!view)
        return null;
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: view.variant, text: view.text, className: className, title: view.title, "data-testid": "fidman-sync-badge" }, view.label));
}
/** Linia pod checkboxem w modalu uprawnień - ten sam stan, pełnym zdaniem. */
function FidmanUserSyncLine({ enabled, sync, }) {
    const view = describeFidmanUserSync(enabled, sync ?? null);
    if (!view)
        return null;
    return (react_1.default.createElement("div", { className: `small mt-1 ${TEXT_CLASS_BY_VARIANT[view.variant]}`, "data-testid": "fidman-sync-line" },
        "Ostatnia wysy\u0142ka do FIDmana: ",
        view.label.replace(/^FIDman: /, ""),
        ". ",
        view.title));
}
